import { SerializedData, Store } from "bernie-core";
import { action, observable } from "mobx";
import { Template, FlexBffTemplateResponse, ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Logger, SystemEvent, SystemEventLevel } from "bernie-logger";
import { BreadcrumbsFlexModuleResult } from "src/typings/microserviceModels/breadcrumbs-flex-module";
import * as fetch from "isomorphic-fetch";

export class TemplateStore extends Store {
  @observable
  public template: Template;
  public breadcrumbsModel: BreadcrumbsFlexModuleResult;

  public constructor(state: SerializedData, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setup(bffResponse: FlexBffTemplateResponse) {
    if (bffResponse) {
      this.template = bffResponse.template;
    }
  }

  /**
   * We need to get the model for Breadcrumbs module (a typical Flex Component).
   * Currently flex-gateway-service does not have a BEX-API spinner so we cannot leverage useQuery.
   * This is a temporary hack in order to do the REST API call to get the desired breadcrumbs data in parallel to the shared-ui bex api calls.
   */
  public fetchAndStoreBreadcrumbsData(context: ExtendedContextStore) {
    if (this.breadcrumbsModel) {
      return;
    }

    const siteId = context.site.id;
    const locale = context.locale;
    const id = context.searchContext.location.id;

    return fetch(
      `https://flex-gateway-service.us-west-2.prod.expedia.com/module/breadcrumbs?id=${id}&locale=${locale}&pageType=Hotel-Reviews&siteId=${siteId}`,
      {
        method: "GET"
      }
    )
      .then(async response => {
        if (response.status >= 400) {
          throw new Error(`Bad response when fetching breadcrumbs data for id=${id}`);
        }

        if (response.status === 204) {
          throw new Error(`No breadcrumbs data for id=${id}`);
        }

        this.breadcrumbsModel = await response.json();
      })
      .catch(e => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.WARN, "BREADCRUMBS_ERROR"), e);
      });
  }
}
